import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import MobileMenu, { MobileMenuButton } from './MobileMenu';
import Logo from './Logo';
import NavLinks from './NavLinks';
import cartStore from '../../../stores/CartStore';
import CartIcon from './CartIcon';
import SocialMediaIcons from './SocialMediaIcons';

const MIXTA_HEADER_IMG =
  'https://santaplaya-bucket.s3.amazonaws.com/MixtaHeader.webp';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const location = useLocation();
  const { pathname } = location;

  // Hide header on certain paths if needed
  if (
    [
      '/login',
      '/register',
      '/reset-password',
      '/confirmation-instruction',
    ].includes(pathname)
  ) {
    return null;
  }

  return (
    <>
      <header
        className="
          fixed 
          md:relative
          w-full 
          bg-transparent
          flex flex-wrap md:flex-nowrap 
          items-center md:items-start 
          justify-between 
          pb-3 md:pb-4 
          z-50
          h-[15vh]
          md:h-[35vh]
        "
      >
        {/* LEFT SIDE: Mixta image + social icons (hidden on small screens) */}
        <div className="hidden md:flex flex-col mr-2">
          <img
            src={MIXTA_HEADER_IMG}
            alt="Mixta Header"
            className="w-auto max-h-60 md:max-h-72 object-contain mb-4"
          />

          {/* Social Icons in a row */}
          <div className="ml-8">
            <SocialMediaIcons />
          </div>
        </div>

        {/* CENTER: LOGO */}
        <div className="flex-grow flex items-center justify-center md:justify-start md:ml-4 mt-2 md:mt-0">
          <Logo />
        </div>

        {/* RIGHT SIDE (desktop): 
            - Stacked vertically (flex-col)
            - NavLinks on top, CartIcon (only on /order), 
              then a row for the Order button pinned right */}
        <div className="hidden lg:flex flex-col w-full lg:w-auto mt-2 md:mt-6">
          <NavLinks />

          {/* 1) A spacer div so that visually it looks like 
      the button is 'below' the NavLinks in the layout. 
      The height should roughly match the button’s height + margins. */}
          <div className="h-16"></div>

          {/* 2) The button is actually fixed in the viewport, but 
      we "simulate" its space above with the spacer. */}
          {!pathname.includes('/order') ? (
            <motion.a
              href="/order"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="
              bg-maroon text-white font-prosto 
              text-sm font-regular rounded-full
              px-12 
              py-3
              justify-end
              fixed   /* Pins it to the viewport */
              top-[14%] /* or top-20, etc. if you want it pinned on top */
              -right-4
              mt-4
            "
            >
              Order Online
            </motion.a>
          ) : (
            <></>
          )}
        </div>
        {pathname === '/order' && (
          <div className="absolute top-4 right-4 ml-4">
            <CartIcon onClick={() => cartStore.openSidebar()} />
          </div>
        )}
        {/* MOBILE MENU BUTTON */}
        <div className="lg:hidden flex items-center mt-12 mr-6">
          <MobileMenuButton toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
        </div>
      </header>

      {/* MOBILE MENU OVERLAY */}
      <MobileMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
    </>
  );
};

export default Header;
